import axios from "axios";
import jsonp from "jsonp";
import PropTypes from "prop-types";
import querystring from "querystring";
import React from "react";
import animationControlHelper from "../utils/animationControlHelper";
import TriggerEvents from "../utils/trigger.events";
import testVideoSrc from "./testVideoSrc";

const triggerEvents = TriggerEvents();

const isValidVideoId = x => !!x.match(/^[a-zA-Z0-9_-]{11}$/);
const YOUTUBE_URL = "https://www.youtube.com";

function normalizeYouTubeURL(url) {
  console.log("normalizeYouTubeURL = " + url);
  // take care of lazy folks youtu.be youtube.com/watch?v=x, etc
  if (
    (url.indexOf("www.youtube") === 0 || url.indexOf("youtube") === 0) &&
    url.indexOf("/") !== -1
  ) {
    url = YOUTUBE_URL + url.substring(url.indexOf("/"));
  }

  if (url.indexOf("list=") !== -1) {
    console.log(
      "normalize to list = " +
        (YOUTUBE_URL + "/list?" + url.split("list=").pop())
    );
    let playlistId = url.split("list=").pop();
    playlistId = playlistId.split("&")[0]; // remove extra parameter
    let playlistURL = YOUTUBE_URL + "/playlist?list=" + playlistId;
    console.log("playlistURL = " + playlistURL);
    return playlistURL;
  }

  // if we dont have a url by this point its likely a fragment
  if (url.indexOf("://") === -1) {
    // if we have a query string, append to watch
    if (url.indexOf("?") === 0 && url.indexOf("v=") !== -1) {
      return YOUTUBE_URL + "/watch" + url;
    }

    if (url.indexOf("v=") === 0) {
      return YOUTUBE_URL + "/watch?" + url;
    }

    // if it looks like a video id.. then ok
    if (isValidVideoId(url)) {
      return YOUTUBE_URL + "/watch?v=" + url;
    }

    // if we have an at sign, treat it as a user
    if (url.indexOf("@") === 0) {
      return YOUTUBE_URL + "/user/" + url.substring(1);
    }

    // allow search: for query
    if (url.indexOf("search:") === 0) {
      // otherwise just treat it as a search
      return (
        YOUTUBE_URL +
        "/results?search_query=" +
        encodeURIComponent(url.substring("search:".length).trim())
      );
    }

    if (url.indexOf("youtu.be/") === 0) {
      return (
        YOUTUBE_URL + "/watch?v=" + url.split("youtu.be/")[1].replace("?", "&")
      );
    }

    // otherwise... lets just assume its a vanity url
    return YOUTUBE_URL + "/c/" + url;
  }

  // switch http:// to https://
  if (url.indexOf("http://") === 0) {
    url = url.replace("http://", "https://");
  }

  console.log("youtube url = " + url);

  // handle youtu.be to links
  if (url.indexOf("youtu.be/") !== -1) {
    return (
      YOUTUBE_URL + "/watch?v=" + url.split("youtu.be/")[1].replace("?", "&")
    );
  }

  // expand embed links..
  if (url.indexOf("/embed/") !== -1) {
    return (
      YOUTUBE_URL + "/watch?v=" + url.split("/embed/")[1].replace("?", "&")
    );
  }

  // ok enough fun..
  return url;
}

function resolveChannelId(name) {
  // REVIEW: embedding API keys like this is bad form, we should move to server
  return new Promise((resolve, reject) => {
    jsonp(
      "https://www.googleapis.com/youtube/v3/channels?key=AIzaSyBeLe4IFTiAGAZF5DyoHkKjavO7b-aoLpM&part=id&forUsername=" +
        name,
      null,
      (err, data) => {
        if (err) {
          reject(err);
        } else {
          try {
            resolve(data.items[0].id);
          } catch (e) {
            resolve();
          }
        }
      }
    );
  });
}

class YouTubePlayer extends React.Component {
  constructor(props) {
    super(props);
    this.playCounter = 0;
    this.state = { errorMsg: "" };
    // check this.props.maxPlayDurations for backwards compatability, if the old props not set then using the new one.
    this.maxPlayDurations =
      this.props.maxPlayDurations > 0
        ? this.props.maxPlayDurations
        : this.props.max_play_durations;
  }

  playTestVideo() {
    const testVideo = document.createElement("video");
    const style = {
      position: "absolute",
      visibility: "hidden"
    };
    Object.assign(testVideo.style, style);
    testVideo.src = testVideoSrc;
    testVideo.volume = 0;
    testVideo.autoplay = true;

    document.body.appendChild(testVideo);

    const testVideoAction = () => {
      if (document.getElementsByTagName("video").length === 0) {
        setTimeout(testVideoAction, 100);
        return;
      }
      const itPlays = testVideo.play();
      if (itPlays !== undefined) {
        itPlays
          .then(() => {
            console.log("Autoplay started!");
            testVideo.parentNode.removeChild(testVideo);
          })
          .catch(error => {
            this.setState(
              {
                forceMute: true
              },
              () => {
                this.player && this.player.mute(true);
              }
            );
            console.log("Autoplay was prevented.");
            testVideo.parentNode.removeChild(testVideo);
          });
      }
    };

    testVideoAction();
  }

  getChromeVersion() {
    const raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
    return raw ? parseInt(raw[2], 10) : false;
  }

  componentDidMount() {
    var self = this;
    console.log("YouTubePlayer: this.props = ", this.props);

    // http://www.youtube.com/embed/cfudXO_vzWk?autohide=1&autoplay=1&cc_load_policy=1&cc_lang_pref=en
    // do not expand if url not contain http

    if (
      this.isValidYoutubeURL(this.props.url) ||
      (this.props.url.indexOf("http://") === -1 &&
        this.props.url.indexOf("https://") === -1)
    ) {
      self.playVideo(self.props.url);
    } else {
      // expand url
      var server =
        process.env.REACT_APP_TOOLS_API_URL +
        "/expand_url?url=" +
        this.props.url;

      axios
        .get(server)
        .then(function(response) {
          console.log("screencloud-apps tool response = ", response);
          var expanded_url = response.data.long_url;
          if (expanded_url) {
            self.playVideo(expanded_url);
          } else {
            self.playVideo(self.props.url);
          }
        })
        .catch(function(response) {
          console.log("screencloud-apps tool error = ", response);
          self.playVideo(self.props.url);
        });
    }

    const chromeVersion = this.getChromeVersion();
    console.log("chromeVersion = ", chromeVersion);
    if (chromeVersion && chromeVersion >= 65) {
      this.playTestVideo();
    }
  }

  UNSAFE_componentWillUpdate(nextProps) {
    // invoked immediately before rendering with new props or state, not for initial 'render'
    // Use this as an opportunity to perform preparation before an update occurs.
    // You cannot use this.setState() in this method. If you need to update state in response to a prop change, use componentWillReceiveProps instead.
    console.log(
      "YouTubePlayer: componentWillUpdate nextProps.preload = ",
      nextProps.preload
    );
    if (this.props.preload !== nextProps.preload) {
      if (nextProps.preload === false) {
        this.onPlayerReady();
      }
    }
  }

  componentWillUnmount() {
    this.clearMaxDurationTimeout();
    this.clearPlayAttempTimeout();
    this.clearAutoPlayAfterEndTimeout();
  }

  isValidYoutubeURL(url) {
    if (
      url.indexOf("www.youtube") !== -1 ||
      url.indexOf("youtube.com") !== -1 ||
      url.indexOf("youtu.be") !== -1
    ) {
      return true;
    }
    return false;
  }

  playVideo(url) {
    console.log("playVideo: url = " + url);
    this.setState({ errorMsg: "" });

    this.getPlayerConfig(url).then(config => {
      this.config = config;
      this.config.events = {
        onReady: e => this.onPlayerReady(e),
        onStateChange: e => this.onPlayerStateChange(e),
        onError: err => this.onPlayerError(err),
        onApiChange: e => this.onApiChange(e)
      };

      console.log("player config", this.config);
      if (!this.props.preload) {
        this.startPlayAttempTimeout();
      }
      setTimeout(() => {
        try {
          this.player = new window.YT.Player("scYoutubePlayer", this.config);
          // hide unwanted splash image, youtube thing when it first start
          this.player.getIframe().style.visibility = "hidden";
          console.log("this.player = ", this.player);
        } catch (err) {
          console.warn("error occur during create window.YT.Player: ", err);
          let errorMsg = "";
          if (err.data) {
            errorMsg = err.data;
          } else {
            errorMsg = err.toString();
          }
          triggerEvents.sendUnknownErrorEvent({
            message: "error occur during create window.YT.Player: " + errorMsg,
            error: err
          });
        }
      }, 50);
    });
  }

  startPlayAttempTimeout() {
    console.log("startPlayAttempTimeout");
    this.clearPlayAttempTimeout();
    this.playAttempTimeout = setTimeout(() => {
      console.log(
        "finished from playAttempTimeout = setTimeout  > this.playAttempTimeout",
        this.playAttempTimeout
      );
      this.finished();
    }, 10000);
  }

  clearPlayAttempTimeout() {
    if (this.playAttempTimeout) {
      clearTimeout(this.playAttempTimeout);
      this.playAttempTimeout = null;
    }
  }

  startMaxDurationTimeout() {
    this.clearMaxDurationTimeout();
    console.log(
      "YouTubePlayer: start maxDurationTimeout : " +
        this.maxPlayDurations +
        "mins"
    );
    this.maxDurationTimeout = setTimeout(() => {
      console.log(
        "YouTubePlayer: maxDurationTimeout EXPIRED : " +
          this.maxPlayDurations +
          "mins"
      );
      this.stopVideo();

      console.log("finished from maxDurationTimeout = setTimeout");
      this.finished();
    }, this.maxPlayDurations * 60 * 1000); // in mins
  }

  clearMaxDurationTimeout() {
    if (this.maxDurationTimeout) {
      clearTimeout(this.maxDurationTimeout);
      this.maxDurationTimeout = null;
    }
  }

  startAutoPlayAfterEndTimeout() {
    this.clearAutoPlayAfterEndTimeout();
    this.autoPlayAfterEnd = setTimeout(() => {
      this.player.seekTo(0, true);
      this.player.playVideo();
      this.autoPlayAfterEnd = null;
    }, 5000);
  }

  clearAutoPlayAfterEndTimeout() {
    if (this.autoPlayAfterEnd) {
      clearTimeout(this.autoPlayAfterEnd);
      this.autoPlayAfterEnd = null;
    }
  }

  updateCaptions() {
    if (
      this.player &&
      typeof this.player.loadModule === "function" &&
      typeof this.player.unloadModule === "function"
    ) {
      var ccOptions = this.player.getOptions();
      console.log("ccOptions = ", ccOptions);
      console.log("this.player = ", this.player);
      console.log("this.props.captions = " + this.props.captions);
      if (
        this.props.captions &&
        (this.props.captions === "true" || this.props.captions === true)
      ) {
        this.player.loadModule("captions");
      } else {
        this.player.unloadModule("captions");
      }
    }

    // load specific language for future
    // player.setOption("captions", "track", {"languageCode": "es"})  //Works for html5 ignored by AS3
  }

  onApiChange(e) {
    console.log("onApiChange", e);
    this.updateCaptions();
  }

  onPlayerReady(e) {
    console.log("onPlayerReady: ", e);

    var delay = 300;
    if (
      this.config.playerVars.listType &&
      this.config.playerVars.listType === "search"
    ) {
      delay = 1200;
    }

    if (this.playerReadyDelay) {
      clearTimeout(this.playerReadyDelay);
      this.playerReadyDelay = null;
    }

    this.playerReadyDelay = setTimeout(() => {
      // The suggestedQuality parameter value can be
      // small, medium, large, hd720, hd1080, highres or default.
      // We recommend that you set the parameter value to default, which instructs YouTube to select the most appropriate playback quality,
      // which will vary for different users, videos, systems and other playback conditions.
      // this.player.setPlaybackQuality(this.props.playback_quality)

      // delay hack for auto starting video
      // will do a proper way no hack !
      // document.getElementById('scYoutubePlayer').style.height = '100vh'

      // review whats this delay about here?

      // console.log('-onPlayerReady- : ' + delay, this.config)
      // console.log('player = ', this.player)
      // console.log('props = ', this.props)

      // console.log('-onPlayerReady- : this.player = ' + this.player)
      // console.log('this.props.shuffle = ', this.props.shuffle)
      // console.log('this.props.preload = ', this.props.preload)

      if (this.player) {
        // this.sendStartedEvent()
        console.log("player is ready !!");
        try {
          console.log("getDuration() = ", this.player.getDuration());
        } catch (err) {
          console.log("catch error: ", err);
        }

        this.startPlayAttempTimeout();

        if (this.props.loop === "true" || this.props.loop === true) {
          this.player.setLoop(true);
        } else {
          this.player.setLoop(false);
        }

        if (
          this.props.mute === true ||
          this.props.mute === "true" ||
          this.state.forceMute === true
        ) {
          this.player.mute(true);
        }

        this.player.playVideo();

        if (this.props.shuffle === true || this.props.shuffle === "true") {
          this.player.setShuffle(true);
          this.player.playVideoAt(0);
        }

        this.updateCaptions(); // to make sure it will check the caption, sometime api is loaded before onApiChange has been added
      } else {
        // delay to retry to play video again
        return setTimeout(() => {
          console.log("retry onPlayerReady");
          if (this.player) {
            // && this.props.preload !== true) {
            this.onPlayerReady();
          }
        }, 500);
      }
    }, delay);

    this.startMaxDurationTimeout();
  }

  finished() {
    console.log("- finished -");

    this.clearPlayAttempTimeout();

    this.playCounter = 0;

    if (this.props.onPlayEnded) {
      this.props.onPlayEnded();
    }

    if (
      typeof this.player.getPlaylist === "function" &&
      this.player.getPlaylist()
    ) {
      this.player.playVideoAt(0);
    } else {
      // this.player.seekTo(0, true)
      if (this.props.loop === true || this.props.loop === "true") {
        this.player.seekTo(0, true);
      } else {
        this.player.stopVideo();

        // added auto attemp play video after 10 seconds
        // in case there is only 1 video in the feed
        // so it not gonna stuck as black screen
        this.startAutoPlayAfterEndTimeout();
      }
    }
  }

  onPlayerStateChange(event) {
    console.log("onPlayerStateChange", event);

    var playbackQuality =
      typeof this.player.getPlaybackQuality === "function"
        ? this.player.getPlaybackQuality()
        : "";
    var playbackResolution = 480;

    if (playbackQuality.indexOf("hd") !== -1) {
      playbackResolution = Number(playbackQuality.split("hd").join(""));
    } else {
      // playbackResolution = playbackQuality
    }

    console.log("playbackQuality", playbackQuality);
    console.log("playbackResolution", playbackResolution);
    console.log(
      "allow_4k_playback = " + (this.props.allow_4k_playback ? "YES" : "NO")
    );

    if (
      this.props.allow_4k_playback === false &&
      (playbackQuality === "highres" || playbackResolution > 1080) &&
      this.state.errorMsg === ""
    ) {
      console.log("force to HD1080");
      if (typeof this.player.setPlaybackQuality === "function") {
        this.player.setPlaybackQuality("hd1080");
      }
    } else if (this.state.errorMsg === "") {
      console.log(
        "this.player.setPlaybackQuality",
        this.props.playback_quality
      );
      // if(typeof this.player.setPlaybackQuality === 'function'){
      //   this.player.setPlaybackQuality(this.props.playback_quality)
      // }
    }

    // console.log('player.getPlaylist: ', player.getPlaylist())
    // -1 (unstarted)
    // 0 (ended)
    // 1 (playing)
    // 2 (paused)
    // 3 (buffering)
    // 5 (video cued)
    // YT.PlayerState.ENDED
    // YT.PlayerState.PLAYING
    // YT.PlayerState.PAUSED
    // YT.PlayerState.BUFFERING
    // YT.PlayerState.CUED

    var playlist =
      typeof event.target.getPlaylist === "function"
        ? event.target.getPlaylist()
        : null;
    // var playIdx = (typeof this.player.getPlaylistIndex === 'function') ? this.player.getPlaylistIndex() : 0

    if (event.data === window.YT.PlayerState.ENDED) {
      console.log("ended", this.player);
      // console.log('PlayerState.ENDED playIdx: ' + playIdx + '   playlist: ', playlist, this.youtubeParams)
      this.clearBufferTimeout();
      this.clearPlayAttempTimeout();

      this.playCounter += 1;

      // if we have count set and have reached it
      if (this.props.count && parseInt(this.props.count) > 0) {
        console.log(
          "this.props.count = " +
            this.props.count +
            "   this.playCounter = " +
            this.playCounter
        );
        if (playlist) {
          console.log("playlist.length = " + playlist.length);
        }

        if (this.playCounter >= parseInt(this.props.count)) {
          // passed count, restart
          console.log("finished from palyCounter > props.count");
          return this.finished();
        } else if (playlist && this.playCounter >= playlist.length) {
          // play till end of playlist
          console.log("finished from playCounter >= playlist.length");
          return this.finished();
        } else if (!playlist) {
          // single video needs restarting
          this.player.seekTo(0, true);

          // if(this.props.loop === true || this.props.loop === 'true'){
          //   this.player.seekTo(0, true)
          // }else{
          //   this.player.stopVideo()
          // }
          return;
        }
        // otherwise playlist continue
      } else {
        if (playlist) {
          console.log("playlist = ", playlist);
          // got to end of playlist
          console.log(
            "player count is not set, this.playCounter = " +
              this.playCounter +
              "   playlist length = " +
              playlist.length
          );
          if (this.playCounter === playlist.length) {
            console.log("finished from playcounter is equal to playlist");
            return this.finished();
          }
        } else {
          // no playlist.. loop video
          console.log("finished from no playlist");
          return this.finished();
        }
      }
    } else if (event.data === window.YT.PlayerState.PLAYING) {
      this.clearBufferTimeout();
      this.clearPlayAttempTimeout();

      if (this.props.preload) {
        this.player.pauseVideo();
        if (!this.isAppPreloaded) {
          this.isAppPreloaded = true;
          triggerEvents.sendAppStatusPreloaded({
            title: "YouTube: " + this.props.url,
            url: this.props.url
          });
        }
      } else if (!this.props.preload && !this.isAppStarted) {
        this.sendStartedEvent();
        this.player.getIframe().style.visibility = "visible";
        console.log("show YOUTUBE !!!!!!!!!!!!!!!!");
      }
    } else if (event.data === window.YT.PlayerState.BUFFERING) {
      this.clearBufferTimeout();
      this.clearPlayAttempTimeout();
      this.bufferTimer = setTimeout(() => this.onBufferTimeout(), 30000);
      // set timeout for buffering to 30 seconds
    } else if (event.data === window.YT.PlayerState.PLAYING) {
      this.clearBufferTimeout();
      this.clearPlayAttempTimeout();
      this.player.getIframe().style.visibility = "visible";
    } else if (event.data === window.YT.PlayerState.UNSTARTED) {
      console.log("PlayerState = UNSTARTED ");
      // this.player.getIframe().style.visibility = 'hidden'
      // When the player first loads a video, it will broadcast an unstarted (-1) event. When a video is cued and ready to play, the player will broadcast a video cued (5) event.
      // if not able to start play, then next
      this.startPlayAttempTimeout();
    }
  }

  sendStartedEvent() {
    if (!this.props.preload && !this.isAppStarted) {
      let duration = 0;
      try {
        duration = this.player.getDuration();
      } catch (err) {
        console.log("sendStartedEvent: catch error : ", err);
      }

      this.isAppStarted = true;
      animationControlHelper.enableAnimation();
      triggerEvents.sendAppStatusStarted({
        duration: duration || "",
        title: "YouTube: " + this.props.url,
        url: this.props.url
      });
    }
  }

  onBufferTimeout() {
    console.log("onBufferTimeout");
    this.clearBufferTimeout();
    // var currentPlayTime = this.player.getCurrentTime()
    // console.log('currentPlayTime: ' + currentPlayTime)
    // this.player.seekTo(currentPlayTime, true)
    console.log("finished from onBufferTimeout = setTimeout");
    this.finished();
    // hack to force the player to reload the video data when freezing
  }

  clearBufferTimeout() {
    if (this.bufferTimer) {
      clearTimeout(this.bufferTimer);
      this.bufferTimer = null;
    }
  }

  onPlayerError(err) {
    console.log("onPlayerError", err);
    // 2 – The request contains an invalid parameter value. For example, this error occurs if you specify a video ID that does not have 11 characters, or if the video ID contains invalid characters, such as exclamation points or asterisks.
    // 5 – The requested content cannot be played in an HTML5 player or another error related to the HTML5 player has occurred.
    // 100 – The video requested was not found. This error occurs when a video has been removed (for any reason) or has been marked as private.
    // 101 – The owner of the requested video does not allow it to be played in embedded players.
    // 150 – This error is the same as 101. It's just a 101 error in disguise!

    var eventData = JSON.parse(err.data);
    console.log("error code = " + eventData.info);

    switch (Number(eventData.info)) {
      case 2:
        this.setState({
          errorMsg: "Video might conatains an invalid parameter."
        });
        triggerEvents.sendMediaErrorEvent({
          message: "Video might conatains an invalid parameter.",
          error: err
        });
        break;

      case 100:
        this.setState({ errorMsg: "The requested video was not found." });
        triggerEvents.sendMediaErrorEvent({
          message: "The requested video was not found.",
          error: err
        });
        break;

      case 101:
        this.setState({
          errorMsg:
            "The owner of the requested video does not allow it to be played in embedded players."
        });
        triggerEvents.sendMediaErrorEvent({
          message:
            "The owner of the requested video does not allow it to be played in embedded players.",
          error: err
        });
        break;

      case 150:
        this.setState({
          errorMsg:
            "The owner of the requested video does not allow it to be played in embedded players."
        });
        triggerEvents.sendMediaErrorEvent({
          message:
            "The owner of the requested video does not allow it to be played in embedded players.",
          error: err
        });
        break;

      default:
        this.setState({ errorMsg: "" });
        triggerEvents.sendMediaErrorEvent({
          message: "Youtube unknown.",
          error: err
        });
        break;
    }

    if (this.playAttempTimeout) {
      clearTimeout(this.playAttempTimeout);
      this.playAttempTimeout = null;
    }

    setTimeout(() => {
      console.log("finished from onPlayerError setTimeout");
      this.finished();
    }, 2000);
  }

  stopVideo() {
    console.log("stopVideo");
    this.player.stopVideo();
  }

  getPlayerConfig(url) {
    function getYoutubePath(t) {
      if (t.indexOf("list=") !== -1) {
        return "playlist";
      } else {
        var urlAfterDomain = t
          .split("?")
          .shift()
          .split("www.youtube.com/")
          .pop();
        urlAfterDomain = urlAfterDomain.split("/").shift();
        return urlAfterDomain;
      }
    }

    function getParams(t) {
      if (t.indexOf("list=") !== -1) {
        return { list: t.split("list=").pop() };
      } else {
        t = t.split("?").pop();
        return querystring.decode(t);
      }
    }

    // bit of magic to fix / build urls
    url = normalizeYouTubeURL(url);
    var path = getYoutubePath(url);
    var params = getParams(url);
    this.youtubeParams = params;

    console.log(
      "getPlayerConfig: " + url + ",  path:" + path + "   this.youtubeParams:",
      this.youtubeParams
    );
    var config = {};
    config.height = "100%";
    config.width = "100%";
    config.playerVars = {
      autohide: 1,
      autoplay: this.props.preload ? 0 : 1,
      controls: 0,
      playsinline: 1,
      showinfo: 0,
      iv_load_policy: 3,
      rel: 0
    };
    // config.playerVars = { autohide: 1, autoplay: (this.props.preload ? 0 : 1), controls: 0, playsinline: 1, showinfo: 0, iv_load_policy: 3, rel: 0, suggestedQuality: this.props.playback_quality }
    // config.suggestedQuality = this.props.playback_quality
    // console.log('config.suggestedQuality = ' + this.props.playback_quality)
    config.error = null;

    if (
      this.props.captions &&
      (this.props.captions === "true" || this.props.captions === true)
    ) {
      // this.player.loadModule('captions')
      config.playerVars.cc_load_policy = 1;
    } else {
      // this.player.unloadModule('captions')
      config.playerVars.cc_load_policy = 0;
    }

    console.log("config.playerVars = ", config.playerVars);
    var channelId = "";

    switch (path) {
      case "watch":
        if (
          url.indexOf("list=") !== -1 ||
          (this.youtubeParams.list && this.youtubeParams.list !== "")
        ) {
          // playlist
          config.playerVars.listType = "playlist";
          config.playerVars.list = this.youtubeParams.list.split("#").shift();
        } else if (this.youtubeParams.v && this.youtubeParams.v !== "") {
          // play a video
          config.videoId = this.youtubeParams.v;
        }
        break;

      case "playlist":
        // surely only playlist here
        config.playerVars.listType = "playlist";
        config.playerVars.list = this.youtubeParams.list.split("#").shift();
        break;

      case "user":
        // user
        config.playerVars.listType = "user_uploads";
        config.playerVars.list = url
          .split("www.youtube.com/user/")
          .pop()
          .split("/")
          .shift();
        break;

      case "c":
        // user
        config.playerVars.listType = "playlist";
        channelId = url
          .split("www.youtube.com/c/")
          .pop()
          .split("/")
          .shift();
        if (channelId.indexOf("UC") !== 0) {
          // looks like we have a channel name
          return resolveChannelId(channelId).then(result => {
            if (!result) {
              // if its not a channel then just treat it as a search
              config.playerVars.listType = "search";
              config.playerVars.list = channelId;
              return config;
            }
            config.playerVars.list = "UU" + result.substring(2);
            return config;
          });
        } else {
          config.playerVars.list = "UU" + channelId.substring(2);
        }
        break;

      case "embed":
        config.videoId = url.split("www.youtube.com/embed/").pop();
        break;

      case "channel":
        config.playerVars.listType = "playlist";
        // var channelId = url.split('https://www.youtube.com/channel/').pop()
        channelId = url
          .split("https://www.youtube.com/channel/")[1]
          .split("/")[0];
        console.log("channelId = " + channelId);
        if (channelId.indexOf("UC") !== 0) {
          // looks like we have a channel name
          return resolveChannelId(channelId).then(result => {
            if (!result) {
              config.playerVars.listType = "search";
              config.playerVars.list = channelId;
              return config;
            }
            config.playerVars.list = "UU" + result.substring(2);
            return config;
          });
        } else {
          config.playerVars.list = "UU" + channelId.substring(2);
        }
        // config.playerVars.list = 'UU' + user.substring(2)
        break;

      case "results":
        config.playerVars.listType = "search";
        config.playerVars.list = params.search_query;
        break;

      default:
        // unmatch, possible error
        config.playerVars.listType = "search";
        config.playerVars.list = encodeURI(url);
        break;
    }

    return Promise.resolve(config);
  }

  render() {
    var wrapperClassName = "";
    var style = { width: "100%", height: "100%" };
    var errorMsg = "";
    var errorMessage = {
      width: "80vw",
      textAlign: "center",
      color: "#AAAAAA",
      fontSize: "1.2em",
      position: "absolute",
      transform: "translate(-50%, 100%)"
    };

    if (this.props.preload === true) {
      wrapperClassName = "preloadState";
    }

    if (this.state.errorMsg !== "") {
      errorMsg = <h2 style={errorMessage}>{this.state.errorMsg}</h2>;
    }

    return (
      <div style={style} className={wrapperClassName}>
        <div id="scYoutubePlayer" />
        <span id="spinner" className="spinner">
          {errorMsg}
        </span>
      </div>
    );
  }
}

YouTubePlayer.propTypes = {
  preload: PropTypes.bool,
  loop: PropTypes.bool,
  shuffle: PropTypes.bool,
  mute: PropTypes.bool,
  onPlayEnded: PropTypes.func,
  captions: PropTypes.bool,
  url: PropTypes.string.isRequired,
  count: PropTypes.string,
  allow_4k_playback: PropTypes.bool,
  playback_quality: PropTypes.string,
  maxPlayDurations: PropTypes.number,
  max_play_durations: PropTypes.number
};

YouTubePlayer.defaultProps = {
  maxPlayDurations: 0,
  max_play_durations: 60 * 12, // 12 hours
  captions: false,
  allow_4k_playback: false,
  preload: false,
  playback_quality: "default" //  'small' // 'default'
};

export default YouTubePlayer;
